import Papa from 'papaparse'
import { z } from 'zod'

const csvSchema = z.array(z.record(z.string(), z.string()))

export const parseCsv = (csv: string): z.infer<typeof csvSchema> => {
  const result = Papa.parse(csv.trim(), {
    header: true,
    skipEmptyLines: true,
  })

  if (result.errors.length > 0) {
    throw new Error(`CSV parse error: ${result.errors[0]?.message}`)
  }

  return csvSchema.parse(result.data)
}
